import React from 'react';
import { Plugins } from '@leverege/plugin';
import { AttributeGridEditor } from '@leverege/ui-attributes';
import CreateEditForm from "./CreateEditForm.js"; // eslint-disable-next-line import/prefer-default-export
export const BlueprintFormFactory = Plugins.createFactory('BlueprintForm', {
  strategy: Plugins.reactStrategy(React, 'type'),
  pluginKey: 'form',
  defaultObject: CreateEditForm
});
export const AttributeValueEditorFormFactory = Plugins.createFactory('AttributeValueEditorForm', {
  strategy: Plugins.reactStrategy(React, 'type'),
  pluginKey: 'form',
  defaultObject: AttributeGridEditor
});